// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_AddItemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/add_item
 *
 * Returns the id of the inserted order item, plus — for an additional service
 * sold on an order that is already confirmed — what happened to the production
 * flow: how many steps were created, and whether the intended insertion point
 * had already gone by.
 *
 * `steps_position_adjusted` true means the additional could not be placed
 * where the flow says it belongs (the terminal block was already reached), so
 * it went to the first still-pending position instead. The UI must warn the
 * operator; production is never silently reopened.
 *
 * Both step fields stay at their defaults for every other add_item call.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_AddItemResponseDados {
item_id: number
steps_generated: number
steps_position_adjusted: boolean
}

export type Orders_AddItemResponse = ApiResponse<Orders_AddItemResponseDados>;

registerResponseContract('Orders_AddItemResponse', {
  item_id:                 { type: 'number',  required: true },
  steps_generated:         { type: 'number',  required: true },
  steps_position_adjusted: { type: 'boolean', required: true },
})
